import { render } from "./RuiMoreVert.vue?vue&type=template&id=3ffa2a90"
const script = {}
script.render = render

export default script